import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT, aurea, logo } from "../data/site";
import { openAiChat } from "../aichat";
import { SocialRow } from "./shared";
import { imgProps } from "./media";

export function ContactBar() {
  return (
    <div className="contactbar" data-testid="contactbar">
      <a href="tel:+3906232514" className="cb-btn cb-call" data-testid="contactbar-call">
        <Phone size={20} /> Chiama
      </a>
      <a href="#assistente-ai" className="cb-btn cb-chat" onClick={(e) => { e.preventDefault(); openAiChat(); }} data-testid="contactbar-chat">
        <MessageCircle size={20} color="#FFFFFF" /> Chat AI
      </a>
    </div>
  );
}

const cols = [
  {
    title: "Esplora",
    links: [
      ["Servizi", "/servizi"],
      ["Obiettivi sensibili", "/obiettivi-sensibili"],
      ["Centrale operativa", "/centrale-operativa"],
      ["Chi siamo", "/chi-siamo"],
      ["Lavora con noi", CONTACT.careerUrl, true],
    ],
    tid: "footer-explore",
  },
  {
    title: "Gruppo e compliance",
    links: [
      ["Axentra Srl", CONTACT.axentraUrl, true],
      ["Astra Srl", CONTACT.astraUrl, true],
      ["Codice etico", "/chi-siamo"],
      ["Responsabilità sociale", "/chi-siamo"],
      ["Reclami sul servizio", "/contatti"],
      ["Preferenze cookie", "/cookie"],
      ["Dichiarazione di accessibilità", "/accessibilita"],
    ],
    tid: "footer-gruppo",
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <img {...imgProps(logo("orion-bianco.png"), { sizes: "220px" })} alt="Orion Security" className="flogo" />
          <p style={{ margin: "0 0 12px" }}>Istituto di vigilanza privata dal 1992. Vigilanza armata e non armata in tutta Italia.</p>
          <SocialRow testid="footer-social" />
          <Link to="/chi-siamo" className="faurea" style={{ alignItems: "flex-start" }} data-testid="footer-aurea">
            <span className="dash" aria-hidden="true" />
            <img {...imgProps(aurea("holding-bianco.png"), { sizes: "120px" })} alt="Aurea Holding 3" />
          </Link>
        </div>
        <div>
          <h3>Contatti</h3>
          <p style={{ margin: 0, lineHeight: 1.8 }} data-testid="footer-contacts">
            {CONTACT.address}
            <br />
            Tel. {CONTACT.phone}
            <br />
            {CONTACT.email}
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title} className="cols" data-testid={c.tid}>
            <h3>{c.title}</h3>
            {c.links.map(([label, to, ext]) =>
              ext ? (
                <a key={label} href={to} target="_blank" rel="noreferrer">
                  {label}
                </a>
              ) : (
                <Link key={label} to={to}>
                  {label}
                </Link>
              )
            )}
          </div>
        ))}
      </div>
      <div className="fbar">
        <p data-testid="footer-legal">
          © 2026 Orion Security Srl – P.IVA 18377831005 – REA RM 1780820 – Capitale sociale € 50.000,00 i.v. – Licenza prefettizia n. 283167 – <Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link> – <Link to="/cookie" data-testid="footer-cookie">Cookie Policy</Link> – <Link to="/whistleblowing" data-testid="footer-whistleblowing">Whistleblowing</Link>
        </p>
      </div>
    </footer>
  );
}
